import {Injectable} from "@angular/core";

@Injectable({ providedIn: 'root' })
  export class SearchTermService {
	public splitSearchTerm(searchTerm: string, supportQuotes?: boolean) : string[] {
		let res: string[] = [];
		let processedSearchTerm = supportQuotes ? this.handleQuotes(searchTerm.replace(/"/g, '\''), res) : searchTerm;

		return res.concat(processedSearchTerm
			.replace(/^[\s\uFEFF\xA0,]+|[\s\uFEFF\xA0,]+$/g, '') // trim with spaces + commas to prevent empty items
			.split(/[\s\uFEFF\xA0,]+/) // split by spaces + commas: http://stackoverflow.com/questions/650022/
			.filter(str => str.length)); // filter out empty strings - should not happen because of the trim
	}

	public checkMatch(stringToCheck:string,searchTerm:string,ignoreCase:boolean=true) {
		if (ignoreCase) {
			stringToCheck = stringToCheck.toLowerCase();
			searchTerm = searchTerm.toLowerCase();
		}
		// check if there's a match before splitting searchTerm
		// strings with linefeed causes issues
		/* if stringToCheck contains searchTerm and searchTerm has a linefeed
		 * once it is split with a white space added in the beginning of each element
		 * it will erroneously detect mismatch
		 * e.g. stringToCheck=first\r\nsecond searchTerm=first\r\nsecond
		 * searchTerm splits to [" first", " second"]
		 * the second element has index -1 in stringToCheck and the function returns false even if strings are equals
		*/
		let misMatchExists = stringToCheck.indexOf(searchTerm) < 0;
		if (misMatchExists) {
			stringToCheck = " "+stringToCheck;
			let searchTerms = this.splitSearchTerm(searchTerm).map(x=>" "+x);
			misMatchExists = searchTerms.some((word) => (stringToCheck.indexOf(word) < 0));
		}
		return !misMatchExists;
	}

	private handleQuotes(searchTerm: string, terms: string[]): string {
		let breakpoints: {
			position: number,
			status: string
		}[] = [];

		let i = -1;
		while ((i = searchTerm.indexOf('\'', i + 1)) !== -1) {
			let status: string;
			if (i === 0 || (i > 0 && searchTerm[i - 1] === ' ')) {
				status = 's';
			} else if (i === searchTerm.length - 1 || (i < searchTerm.length - 1 && searchTerm[i + 1] === ' ')) {
				status = 'e';
			}
			breakpoints.push({position: i, status: status});
		}

		if (breakpoints.length) {
			let checked: number[] = [];
			let blocks: {
				start: number,
				end: number
			}[] = [];

			for (let j = 0; j < breakpoints.length; j++) {
				if (!checked.includes(breakpoints[j].position) && breakpoints[j].status === 's') {
					checked.push(breakpoints[j].position);
					let start = breakpoints[j].position;
					let end;
					for (let k = j + 1; k < breakpoints.length; k++) {
						if (!checked.includes(breakpoints[k].position)) {
							checked.push(breakpoints[k].position);
							if (breakpoints[k].status === 's' || breakpoints[k].status === 'e') {
								end = breakpoints[k].position;
								break;
							}
						}
					}

					if (end && (end - start > 1)) {
						blocks.push({start: start, end: end});
					}
				}
			}

			if (blocks.length) {
				blocks.reverse().forEach(b => {
					terms.push(searchTerm.substring(b.start + 1, b.end).trim());
					searchTerm = searchTerm.substring(0, b.start) + searchTerm.substring(b.end + 1);
				});
			}
		}

		return searchTerm;
	}
}
